var map = {
	"./ARA.json": "91dd",
	"./CHI.json": "1612",
	"./DUT.json": "2056",
	"./ENG.json": "fd0a",
	"./FRE.json": "126b",
	"./GER.json": "4a02",
	"./HIN.json": "faf0",
	"./IND.json": "5c64",
	"./ITA.json": "f47b",
	"./JPN.json": "6226",
	"./KOR.json": "079eb",
	"./POR.json": "daba",
	"./RUS.json": "69b3",
	"./SPA.json": "a2ea"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "beae";